// extracted by mini-css-extract-plugin
var _1 = "InvalidUserForSchoolModal__studentAvatar--ms4od";
var _2 = "InvalidUserForSchoolModal__studentLink--nzv03";
var _3 = "InvalidUserForSchoolModal__studentList--lwLkO";
export { _1 as "studentAvatar", _2 as "studentLink", _3 as "studentList" }
